module.exports = __webpack_public_path__ + "static/media/repair-active.b667f753.svg";